<div class="card">
    <!-- Header -->
    <div class="card-header">
      <div class="user-info">
        <strong>{{approvalData?.userAssigned?.fullName}}</strong> - <span class="role">{{approvalData?.designation?.title}}</span>
      </div>
      <div class="days">{{ daysDifference }} day(s)</div>
    </div>

    <!-- Body -->
    <div class="card-body">
      <!-- <p><strong>kindly approve this file</strong></p> -->
      <p class="dates">
        Assigned Date: <a href="#">{{ approvalData?.assignedAt | date: 'MMM, dd yyyy : HH:mm:ss'}}</a>,  
        Forward Date: <a href="#">{{approvalData?.createdAt| date:'MMM, dd yyyy : HH:mm:ss'}}</a>
      </p>

      <div class="level-description">
        {{approvalData?.comment}}
      </div>
      <div class="level-status">
        <div class="level">Level : <span>1.00</span></div>
        <div class="status">Status : <strong>{{approvalData.status == 'Completed' ? 'Forwarded' : approvalData.status}}</strong> <span class="icon">↪</span></div>
        
      </div>
    </div>
  </div>
